var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_191_2790)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.67822 7.89209C3.67822 6.78752 4.57365 5.89209 5.67822 5.89209H27.6782C28.7828 5.89209 29.6782 6.78752 29.6782 7.89209V21.8921C29.6782 22.9967 28.7828 23.8921 27.6782 23.8921H5.67822C4.57365 23.8921 3.67822 22.9967 3.67822 21.8921V7.89209ZM27.6782 7.89209H5.67822V21.8921H27.6782V7.89209ZM14.2064 10.0104C14.5315 9.8364 14.9261 9.85547 15.2329 10.06L21.2329 14.06C21.5111 14.2455 21.6782 14.5577 21.6782 14.8921C21.6782 15.2264 21.5111 15.5387 21.2329 15.7241L15.2329 19.7241C14.9261 19.9287 14.5315 19.9478 14.2064 19.7738C13.8812 19.5997 13.6782 19.2609 13.6782 18.8921V10.8921C13.6782 10.5233 13.8812 10.1844 14.2064 10.0104ZM15.6782 17.0236L18.8754 14.8921L15.6782 12.7606V17.0236ZM4.67822 25.8921C4.12594 25.8921 3.67822 26.3398 3.67822 26.8921C3.67822 27.4444 4.12594 27.8921 4.67822 27.8921H28.6782C29.2305 27.8921 29.6782 27.4444 29.6782 26.8921C29.6782 26.3398 29.2305 25.8921 28.6782 25.8921H4.67822Z",
    fill: "url(#paint0_linear_191_2790)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_191_2790",
    x1: 3.67822,
    y1: 5.89209,
    x2: 29.0281,
    y2: 27.8921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE49D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FED961"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FEE180"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FFE99D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFCA47"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_191_2790"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.678223 0.89209)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/Video.ba710b630483ae292c76e0b2cc61dc8f.svg";
export { ForwardRef as ReactComponent };